export abstract class LanguageService {
  abstract setCurrentLanguage(locale: string);
}
